import React from 'react';
import styled from 'styled-components';
import { Button } from '../styles/GlobalStyles';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 32px;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  
  @media (max-width: 768px) {
    padding: 24px;
    max-width: 90vw;
  }
`;

const ModalTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 16px;
  text-align: center;
`;

const ModalText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: #495057;
  margin-bottom: 24px;
  
  p {
    margin-bottom: 16px;
  }
  
  strong {
    color: #212529;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

interface PrivacyModalProps {
  onAccept: () => void;
  onReject: () => void;
}

const PrivacyModal: React.FC<PrivacyModalProps> = ({ onAccept, onReject }) => {
  return (
    <ModalOverlay>
      <ModalContent>
        <ModalTitle>Termos de Uso e Privacidade</ModalTitle>
        
        <ModalText>
          <p>
            A Connecting Food coleta e trata os dados fornecidos neste formulário para fins de cadastro, gestão de parcerias e viabilização da redistribuição de alimentos.
          </p>
          <p>
            Os dados relacionados a resultados de impacto social podem ser compartilhados com os doadores, tais como área de atuação, número de atendidos, perfil de atendidos.
          </p>
          <p>
            Adotamos práticas de segurança para proteger suas informações, incluindo controle de acesso e armazenamento seguro. Você pode, a qualquer momento, solicitar acesso, correção ou exclusão dos seus dados, bem como exercer outros direitos previstos na legislação vigente.
          </p>
          <p>
            Para mais informações sobre como tratamos seus dados, consulte nossa Política de Privacidade disponível em <a href="https://connectingfood.com/politica-de-privacidade.htm" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>.
          </p>
          <p>
            Caso tenha dúvidas ou queira exercer seus direitos, entre em contato com nosso Encarregado de Proteção de Dados:
          </p>
          <p>
            <strong>E-mail:</strong> ti@connectingfood.com
          </p>
        </ModalText>
        
        <ButtonGroup>
          <Button variant="danger" onClick={onReject}>
            Recusar
          </Button>
          <Button onClick={onAccept}>
            Aceitar
          </Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default PrivacyModal;